import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-759e4f04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, " 커뮤니티 ", -1))
const _hoisted_5 = { id: "write_form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "write_form_txt" }, "해당 글은 익명이 보장된 게시글입니다.", -1))
const _hoisted_7 = { class: "form_btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("form", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              id: "wr_title",
              placeholder: "제목",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.state.title) = $event))
            }, null, 512), [
              [_vModelText, $setup.state.title]
            ]),
            _withDirectives(_createElementVNode("textarea", {
              id: "wr_cotnent",
              placeholder: "내용을 입력하세요",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.content) = $event))
            }, null, 512), [
              [_vModelText, $setup.state.content]
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.SaveBtn && $setup.SaveBtn(...args))),
                class: "submit_btn"
              }, "작성완료"),
              _createVNode(_component_router_link, {
                to: "#",
                onClick: $setup.backList,
                class: "cancle_btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("취소")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"]),
    _createVNode(_component_GnbLayout)
  ], 64))
}